import axios from 'axios';

import type { AwNuxtAppExtensions } from '~~/common/types/nuxt-app-extensions';
import type { AxiosError } from 'axios';

const vimeoMetaRequestCache: Record<string, Promise<{ thumbnail_url: string }>> = {};

/**
 * @description https://developer.vimeo.com/api/oembed/videos
 */
export async function vimeoMeta ({
  videoId,
  isCacheEnabled = true,
  $logger = console,
}: {
  videoId?: string;
  isCacheEnabled?: boolean;
  $logger?: AwNuxtAppExtensions['$logger'] | typeof console;
} = {
  $logger: console,
}) {
  if (typeof videoId !== 'string') {
    $logger.warn(`Video id ${videoId} is not string.`);
    return { thumbnail_url: '' };
  }
  if (isCacheEnabled && vimeoMetaRequestCache[videoId]) {
    return vimeoMetaRequestCache[videoId];
  }
  vimeoMetaRequestCache[videoId] = unCached(videoId, $logger);
  const resp = vimeoMetaRequestCache[videoId];
  // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
  delete vimeoMetaRequestCache[videoId as keyof typeof vimeoMetaRequestCache];
  return await resp;
}

async function unCached (videoId: string, $logger: AwNuxtAppExtensions['$logger'] | typeof console) {
  let thumbnailUrl = '';
  try {
    const { data: { thumbnail_url: tu } } = await axios({
      method: 'GET',
      url: 'https://vimeo.com/api/oembed.json',
      params: {
        url: `https://vimeo.com/${videoId}`,
      },
    });
    thumbnailUrl = typeof tu === 'string' ? tu : '';
  } catch (error) {
    const axiosError: AxiosError = error as AxiosError;
    if (axiosError.response?.status === 404) {
      $logger.error(`Video not found: ${videoId}`);
    } else {
      $logger.error(error);
    }
  }
  return {
    thumbnail_url: thumbnailUrl,
  };
}
